import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import { TripFull } from '@/models/trip'

import { useTripsStore } from '@/store/trips'

import { RbacAction, RbacEntity } from '@/helpers/rbac'

import CancellationRequestItem from '@/components/CancellationRequestItem.vue'
import useScopeCheck from '@/composables/useScopeCheck'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancellationRequestsSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const tripsStore = useTripsStore()

const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.TRIPS)

const requestsModule =
  tripsStore.tripsDetails[props.trip.id]?.cancellationRequestsModule

const commentLoadingList = computed(
  () => requestsModule?.commentUpdating.loadingList || []
)
const commentSuccessList = computed(
  () => requestsModule?.commentUpdating.successList || []
)

const resolvingLoadingList = computed(
  () => requestsModule?.resolving.loadingList || []
)

const handleCommentUpdateClick = (
  tripId: string,
  requestId: string,
  comment: string
) => {
  tripsStore.createCancellationRequestComment(tripId, requestId, comment)
}

const handleResolveClick = (tripId: string, requestId: string) => {
  tripsStore.resolveCancellationRequest(tripId, requestId)
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trip.cancellation_requests, (request) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          key: request.id,
          span: 24
        }, {
          default: _withCtx(() => [
            _createVNode(CancellationRequestItem, {
              editable: _unref(allowedEditing),
              trip: _ctx.trip,
              request: request,
              isCommentUpdating: commentLoadingList.value.includes(request.id),
              isSuccessCommentUpdating: commentSuccessList.value.includes(request.id),
              isResolving: resolvingLoadingList.value.includes(request.id),
              onUpdateComment: handleCommentUpdateClick,
              onResolveRequest: handleResolveClick
            }, null, 8, ["editable", "trip", "request", "isCommentUpdating", "isSuccessCommentUpdating", "isResolving"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})